"use client";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ___$insertStyle(css) {
  if (!css || typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

___$insertStyle(".marquee-container {\n  overflow-x: hidden !important;\n  display: flex !important;\n  flex-direction: row !important;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.overlay::before, .overlay::after {\n  background: linear-gradient(to right, var(--gradient-color));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n}\n.overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n}\n\n.child {\n  transform: var(--transform);\n}");

var Marquee = React.forwardRef(function Marquee(_ref, ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$autoFill = _ref.autoFill,
      autoFill = _ref$autoFill === void 0 ? false : _ref$autoFill,
      _ref$play = _ref.play,
      play = _ref$play === void 0 ? true : _ref$play,
      _ref$pauseOnHover = _ref.pauseOnHover,
      pauseOnHover = _ref$pauseOnHover === void 0 ? false : _ref$pauseOnHover,
      _ref$pauseOnClick = _ref.pauseOnClick,
      pauseOnClick = _ref$pauseOnClick === void 0 ? false : _ref$pauseOnClick,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "left" : _ref$direction,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 50 : _ref$speed,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? 0 : _ref$loop,
      _ref$gradient = _ref.gradient,
      gradient = _ref$gradient === void 0 ? false : _ref$gradient,
      _ref$gradientColor = _ref.gradientColor,
      gradientColor = _ref$gradientColor === void 0 ? [255, 255, 255] : _ref$gradientColor,
      _ref$gradientWidth = _ref.gradientWidth,
      gradientWidth = _ref$gradientWidth === void 0 ? 200 : _ref$gradientWidth,
      onFinish = _ref.onFinish,
      onCycleComplete = _ref.onCycleComplete,
      children = _ref.children;

  // React Hooks
  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      containerWidth = _React$useState2[0],
      setContainerWidth = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      marqueeWidth = _React$useState4[0],
      setMarqueeWidth = _React$useState4[1];

  var _React$useState5 = React.useState(1),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      multiplier = _React$useState6[0],
      setMultiplier = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      isMounted = _React$useState8[0],
      setIsMounted = _React$useState8[1];

  var rootRef = React.useRef(null);
  var containerRef = ref || rootRef;
  var marqueeRef = React.useRef(null); // Calculate width of container and marquee and set multiplier

  var calculateWidth = React.useCallback(function () {
    if (marqueeRef.current && containerRef.current) {
      var containerRect = containerRef.current.getBoundingClientRect();
      var marqueeRect = marqueeRef.current.getBoundingClientRect();
      var _containerWidth = containerRect.width;
      var _marqueeWidth = marqueeRect.width; // Swap width and height if direction is up or down

      if (direction === "up" || direction === "down") {
        _containerWidth = containerRect.height;
        _marqueeWidth = marqueeRect.height;
      }

      if (autoFill && _containerWidth && _marqueeWidth) {
        setMultiplier(_marqueeWidth < _containerWidth ? Math.ceil(_containerWidth / _marqueeWidth) : 1);
      } else {
        setMultiplier(1);
      }

      setContainerWidth(_containerWidth);
      setMarqueeWidth(_marqueeWidth);
    }
  }, [autoFill, containerRef, direction]); // Calculate width and multiplier on mount and on window resize

  React.useEffect(function () {
    if (!isMounted) return;
    calculateWidth();

    if (marqueeRef.current && containerRef.current) {
      var resizeObserver = new ResizeObserver(function () {
        return calculateWidth();
      });
      resizeObserver.observe(containerRef.current);
      resizeObserver.observe(marqueeRef.current);
      return function () {
        if (!resizeObserver) return;
        resizeObserver.disconnect();
      };
    }
  }, [calculateWidth, containerRef, isMounted]); // Recalculate width when children change

  React.useEffect(function () {
    calculateWidth();
  }, [calculateWidth, children]);
  React.useEffect(function () {
    setIsMounted(true);
  }, []); // Animation duration

  var duration = React.useMemo(function () {
    if (autoFill) {
      return marqueeWidth * multiplier / speed;
    } else {
      return marqueeWidth < containerWidth ? containerWidth / speed : marqueeWidth / speed;
    }
  }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]); // Gradient color in an unfinished rgba format

  var rgbaGradientColor = "rgba(".concat(gradientColor[0], ", ").concat(gradientColor[1], ", ").concat(gradientColor[2]);
  var containerStyle = React.useMemo(function () {
    var _Object$assign;

    return Object.assign(Object.assign({}, style), (_Object$assign = {}, _defineProperty(_Object$assign, "--pause-on-hover", !play || pauseOnHover ? "paused" : "running"), _defineProperty(_Object$assign, "--pause-on-click", !play || pauseOnHover && !pauseOnClick || pauseOnClick ? "paused" : "running"), _defineProperty(_Object$assign, "--width", direction === "up" || direction === "down" ? "100vh" : "100%"), _defineProperty(_Object$assign, "--transform", direction === "up" ? "rotate(-90deg)" : direction === "down" ? "rotate(90deg)" : "none"), _Object$assign));
  }, [style, play, pauseOnHover, pauseOnClick, direction]);
  var gradientStyle = React.useMemo(function () {
    var _ref2;

    return _ref2 = {}, _defineProperty(_ref2, "--gradient-color", "".concat(rgbaGradientColor, ", 1), ").concat(rgbaGradientColor, ", 0)")), _defineProperty(_ref2, "--gradient-width", typeof gradientWidth === "number" ? "".concat(gradientWidth, "px") : gradientWidth), _ref2;
  }, [rgbaGradientColor, gradientWidth]);
  var marqueeStyle = React.useMemo(function () {
    var _ref3;

    return _ref3 = {}, _defineProperty(_ref3, "--play", play ? "running" : "paused"), _defineProperty(_ref3, "--direction", direction === "left" ? "normal" : "reverse"), _defineProperty(_ref3, "--duration", "".concat(duration, "s")), _defineProperty(_ref3, "--delay", "".concat(delay, "s")), _defineProperty(_ref3, "--iteration-count", !!loop ? "".concat(loop) : "infinite"), _defineProperty(_ref3, "--min-width", autoFill ? "auto" : "100%"), _ref3;
  }, [play, direction, duration, delay, loop, autoFill]);
  var childStyle = React.useMemo(function () {
    return _defineProperty({}, "--transform", direction === "up" ? "rotate(90deg)" : direction === "down" ? "rotate(-90deg)" : "none");
  }, [direction]); // Render {multiplier} number of children

  var multiplyChildren = React.useCallback(function (multiplier) {
    return _toConsumableArray(Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0)).map(function (_, i) {
      return React__default['default'].createElement(React.Fragment, {
        key: i
      }, React.Children.map(children, function (child) {
        return React__default['default'].createElement("div", {
          style: childStyle,
          className: "child"
        }, child);
      }));
    });
  }, [childStyle, children]);
  return !isMounted ? null : React__default['default'].createElement("div", {
    ref: containerRef,
    style: containerStyle,
    className: "marquee-container " + className
  }, gradient && React__default['default'].createElement("div", {
    style: gradientStyle,
    className: "overlay"
  }), React__default['default'].createElement("div", {
    className: "marquee",
    style: marqueeStyle,
    onAnimationIteration: onCycleComplete,
    onAnimationEnd: onFinish
  }, React__default['default'].createElement("div", {
    className: "initial-child-container",
    ref: marqueeRef
  }, React.Children.map(children, function (child) {
    return React__default['default'].createElement("div", {
      style: childStyle,
      className: "child"
    }, child);
  })), multiplyChildren(multiplier - 1)), React__default['default'].createElement("div", {
    className: "marquee",
    style: marqueeStyle
  }, multiplyChildren(multiplier)));
});
exports.default = Marquee;